







import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class SortInput extends Vue {
  @Prop({ default: false })
  value: boolean | null

  @Prop({ default: '' })
  label: string

  @Prop({ default: false })
  nullable: boolean

  asc: boolean | null = false

  toggle () {
    const cycle: (boolean | null)[] = [false, true]
    if (this.nullable) {
      cycle.push(null)
    }

    const index = cycle.indexOf(this.asc)
    if (index >= 0) {
      this.asc = cycle[(index + 1) % cycle.length]
      this.$emit('input', this.asc)
    }
  }

  @Watch('value', { immediate: true })
  onValueChanged (newVal: boolean) {
    this.asc = newVal
  }
}
